export const BOOKING_URL =
    "https://app.studioninja.co/booking//Q67C28W1U6U0G1035E856J8LG";

export const ADDRESS = {
    line1: "Unit 6 Hodgson Court, Hodgson Way",
    line2: "Wickford, Essex, SS11 8XR",
    full: "Unit 6 Hodgson Court, Hodgson Way, Wickford, Essex, SS11 8XR",
};

export const MAPS_DIR_URL =
    "https://www.google.com/maps/dir/?api=1&destination=Unit+6+Hodgson+Court%2C+Hodgson+Way%2C+Wickford+SS11+8XR";

export const MAPS_EMBED_URL =
    "https://www.google.com/maps?q=Unit+6+Hodgson+Court,+Hodgson+Way,+Wickford+SS11+8XR&output=embed";

export const IMAGES = {
    sleigh:
        "https://customer-assets-39nsmqrw.emergentagent.net/job_b2cd60cb-85da-48b6-9c1c-8c2ad4d7ed80/artifacts/19422733ade35816_WVE%20XMAS%20MINI%20SHOOTS.jpg",
    toyshop:
        "https://customer-assets-39nsmqrw.emergentagent.net/job_b2cd60cb-85da-48b6-9c1c-8c2ad4d7ed80/artifacts/65a5d8a879f66f81_WhatsApp%20Image%202026-10-14%20at%2009.17.10.jpeg",
    familyStudio:
        "https://images.unsplash.com/photo-1760328249117-18488466e34c?auto=format&fit=crop&w=900&q=80",
    familyTree:
        "https://images.unsplash.com/photo-1646115206701-04fcbfa4152d?auto=format&fit=crop&w=900&q=80",
    familyDog:
        "https://images.unsplash.com/photo-1705363134717-0210c88d2689?auto=format&fit=crop&w=900&q=80",
};

export const NAV_LINKS = [
    { label: "The Sets", href: "#sets" },
    { label: "Included", href: "#included" },
    { label: "Reviews", href: "#reviews" },
    { label: "FAQ", href: "#faq" },
    { label: "Find Us", href: "#visit" },
];

export const MARQUEE_ITEMS = [
    "Santa's Sleigh Set",
    "Lapland Workshop",
    "20-Minute Session",
    "3 Edited Digital Images",
    "Pets Welcome",
    "Up To 5 Family Members",
    "Earlybird £49",
    "Wickford · Essex",
];

export const FAQS = [
    {
        q: "What is included in the £49 earlybird booking?",
        a: "A 20-minute private studio session on both Christmas sets, Santa's Sleigh and the Lapland Workshop, plus 3 beautifully edited digital images. Optional print and frame upgrades are available. Full session details are on the booking page.",
    },
    {
        q: "How many family members can come?",
        a: "Each £49 booking covers up to 5 family members. If your group is larger, please check with the studio before booking.",
    },
    {
        q: "Can we bring our family pet?",
        a: "Yes, pets are very welcome and love joining the Christmas shoot with the whole family.",
    },
    {
        q: "Can I buy prints or frames of my images?",
        a: "Yes, alongside your 3 included digital images, optional print and frame upgrades are available so your favourites can go straight on the wall or the mantelpiece.",
    },
    {
        q: "Where is the studio located?",
        a: "Essex Photography Studio, Unit 6 Hodgson Court, Hodgson Way, Wickford, Essex, SS11 8XR. Directions are in the Find Us section below.",
    },
];
